<script>
    export let value

    export let placeholder = ''
    export let label       = ''
    export let id          = ''

    let is_hidden = true

    const toggle_hidden = () => is_hidden = !is_hidden
</script>

<label class="label" for={id}>{label}</label>
<div class="field has-addons">

    <div class="control is-expanded">

        {#if is_hidden}
            <input
                class="input"
                type="password"
                bind:value={value}
                placeholder={placeholder}
                id={id}/>
        {:else}
            <input
                class="input"
                type="text"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                bind:value={value}
                placeholder={placeholder}
                id={id}/>

        {/if}
    </div>

    <div class="control">
        <button
            type="button"
            class="button"
            on:click={toggle_hidden}>
            <span class="icon">
                {#if is_hidden}
                    <i class="fas fa-eye"></i>
                {:else}
                    <i class="fas fa-eye-slash"></i>
                {/if}
            </span>
        </button>
    </div>
    

</div>


